// src/hooks/useHomepageContent.js
// Ana səhifə admin-idarəli məzmun bloklarını (homepageStats, homepageCta) public
// /site-settings-dən bir dəfə çəkir (modul keş). Yüklənənədək null qaytarır →
// komponentlər öz fallback-ı ilə render olunur (regresiya yoxdur).
import { useEffect, useState } from 'react'
import api from '../api/api'

let cache = null
let inflight = null
const subs = new Set()
const notify = () => subs.forEach((fn) => fn(cache))

const fetchOnce = () => {
    if (inflight) return inflight
    inflight = api.get('/site-settings')
        .then(({ data }) => {
            const d = data?.data || {}
            cache = { stats: d.homepageStats || null, cta: d.homepageCta || null }
            notify()
            return cache
        })
        .catch(() => cache)
        .finally(() => { inflight = null })
    return inflight
}

export const useHomepageContent = () => {
    const [state, setState] = useState(cache)
    useEffect(() => {
        subs.add(setState)
        if (cache) setState(cache)
        else fetchOnce()
        return () => { subs.delete(setState) }
    }, [])
    return state // null | { stats, cta }
}
